
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/automation-sdk",
      function () {
        return require("private-next-pages/guides/automation-sdk.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/automation-sdk"])
      });
    }
  